function newsletterSignup() {
    // document.addEventListener('DOMContentLoaded', function() {
        var ajxForm = document.getElementById("newsletter-form");
        if (ajxForm) {
            ajxForm.onsubmit = function(event){
                event.preventDefault();
                var data = new FormData(ajxForm);
                // data.append("referer",window.location.href);
                data.append("referer",window.location.host);
                var xhr = new XMLHttpRequest();
                xhr.open("GET", "/ajax/facelift/newsletter-signup.php?email="+data.get('email')+"&fname="+data.get('fname')+"&lname="+data.get('lname'), true);
                xhr.withCredentials = true;
                xhr.onreadystatechange = function() {
                    if (xhr.readyState == XMLHttpRequest.DONE) {
                        ajxForm.reset(); //reset form after AJAX success.
                    }
                }
                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.send(data);
                xhr.onload = function() {
                    //eval('success = ' + xhr.responseText);
                    // if (success) {
                        document.getElementById("newsletter-heading").innerHTML = 'Thank you for subscribing!';
                    // }
                };
                return false;
            }
        }
    // });
}

export default newsletterSignup;